import React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableItem from './TableItem';
import AppTableContainer from '@projectK/components/AppTableContainer';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { TableCell, TableSortLabel, TableRow } from '@mui/material';
import { Fonts } from '@projectK/constants';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppTableLoader from '@projectK/components/AppTableLoader';
import AppTableNoData from '@projectK/components/AppTableNoData';
import PropTypes from 'prop-types';
const WaiverLogTable = ({
  waiversLogData,
  verbiageSettings,
  loading,
  fetchData,
  titleSorting,
  descriptionSorting,
  productSorting,
  userSorting,
  dateSorting,
  setTitleSorting,
  setDescriptionSorting,
  setProductSorting,
  setUserSorting,
  setDateSorting,
  exportLoading,
}) => {
  const companyTheme = CompanyTheme();
  const parseContent = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    return doc.body.textContent || '';
  };
  const updatedData = waiversLogData?.map((waiver) => ({
    ...waiver,
    waiver_description: waiver?.description,
    description: parseContent(waiver?.description),
  }));

  const handleSort = (column) => {
    setTitleSorting(column === 'waiver_name' ? !titleSorting : null);
    setDescriptionSorting(
      column === 'description' ? !descriptionSorting : null,
    );
    setUserSorting(column === 'first_name' ? !userSorting : null);
    setDateSorting(column === 'created_at' ? !dateSorting : null);
  };
  const canHideSortIcon = (column) => {
    const columnToState = {
      waiver_name: titleSorting,
      description: descriptionSorting,
      first_name: userSorting,
      created_at: dateSorting,
    };
    for (const columnName in columnToState) {
      if (columnName !== column && columnToState[columnName] !== null) {
        return true;
      }
    }
    return false;
  };
  return (
    <AppTableContainer className="app-table-container">
      <AppTableLoader loading={loading || exportLoading} className={'app-table-loader'}/>
        <AppScrollbar className='max-h'>
        <Table stickyHeader>
          <TableHead
            sx={{
              borderBottom: '0 none',
              '& .tableCell': {
                fontSize: 13,
                padding: 2,
                fontWeight: Fonts.BOLD,
                backgroundColor: companyTheme
                  ? companyTheme.primary.main
                  : '#211251',
                color: '#ffffff',
                '&:first-of-type': {
                  pl: 5,
                },
                '&:last-of-type': {
                  pr: 5,
                },
              },
            }}
          >
            <TableRow>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={titleSorting}
                  direction={titleSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('waiver_name')}
                  hideSortIcon={canHideSortIcon('waiver_name')}
                >
                  Title
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell'>
                <TableSortLabel
                  active={descriptionSorting}
                  direction={descriptionSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('description')}
                  hideSortIcon={canHideSortIcon('description')}
                >
                  Text
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='left'>
                <TableSortLabel
                  active={userSorting}
                  direction={userSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('first_name')}
                  hideSortIcon={canHideSortIcon('first_name')}
                >
                  Participant
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='left'>
                <TableSortLabel
                  active={dateSorting}
                  direction={dateSorting ? 'asc' : 'desc'}
                  onClick={() => handleSort('created_at')}
                  hideSortIcon={canHideSortIcon('created_at')}
                >
                  Signed on
                </TableSortLabel>
              </TableCell>
              <TableCell className='tableCell' align='center'>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
           <TableBody>
            {updatedData.length > 0 ? (
               updatedData?.map((data) => (
                <TableItem
                  data={data}
                  key={data.user_waiver_id}
                  fetchData={fetchData}
                  verbiageSettings={verbiageSettings}
                />
              ))
              ) : (
             <AppTableNoData
               colSpan={5}
               message="No Waivers Log Found"
               loading={loading}
               />
              )}
         </TableBody>
        </Table>
      </AppScrollbar>
    </AppTableContainer>
  );
};

export default WaiverLogTable;
WaiverLogTable.propTypes = {
  waiversLogData: PropTypes.array,
  verbiageSettings: PropTypes.object,
  loading: PropTypes.bool,
  fetchData: PropTypes.func,
  titleSorting: PropTypes.bool,
  descriptionSorting: PropTypes.bool,
  productSorting: PropTypes.bool,
  userSorting: PropTypes.bool,
  dateSorting: PropTypes.bool,
  setTitleSorting: PropTypes.func,
  setDescriptionSorting: PropTypes.func,
  setProductSorting: PropTypes.func,
  setUserSorting: PropTypes.func,
  setDateSorting: PropTypes.func,
  exportLoading: PropTypes.bool,
};
